import React from 'react';
import { Users, FileText, CheckCircle, Brain } from 'lucide-react';
import type { JournalStats } from '../types';

interface StatsPanelProps {
  stats: JournalStats;
}

export const StatsPanel: React.FC<StatsPanelProps> = ({ stats }) => {
  const statCards = [
    {
      label: 'Enrolled Students',
      value: stats.enrolled_students,
      icon: Users,
      color: 'bg-blue-100 text-blue-600',
    },
    {
      label: 'Total Entries',
      value: stats.entries_count,
      icon: FileText,
      color: 'bg-purple-100 text-purple-600',
    },
    {
      label: 'Submissions',
      value: stats.total_submissions,
      icon: CheckCircle,
      color: 'bg-green-100 text-green-600',
    },
    {
      label: 'AI Feedback Rate',
      value: stats.ai_feedback_rate,
      icon: Brain,
      color: 'bg-amber-100 text-amber-600',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statCards.map((stat, index) => (
        <div key={index} className="bg-white rounded-xl p-4 shadow-sm border border-slate-200">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${stat.color}`}>
              <stat.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stat.value}</p>
              <p className="text-xs text-slate-500">{stat.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
